import { FiInbox } from 'react-icons/fi';
import { useDarkMode } from '../../context/DarkModeContext';

export default function EmptyState({
  icon: Icon = FiInbox,
  title,
  description,
  action,
  actionLabel,
  iconSize = 48,
}) {
  const { COL } = useDarkMode();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 20px',
        textAlign: 'center',
      }}
    >
      <Icon size={iconSize} style={{ opacity: 0.15, marginBottom: '16px', color: COL.pri }} />
      <div style={{ fontSize: '15px', fontWeight: 600, color: COL.pri, marginBottom: '4px' }}>
        {title}
      </div>
      {description && (
        <div style={{ fontSize: '13px', color: COL.muted, maxWidth: '300px' }}>{description}</div>
      )}
      {action && actionLabel && (
        <button
          onClick={action}
          style={{
            marginTop: '16px',
            padding: '10px 20px',
            borderRadius: '10px',
            border: 'none',
            background: COL.pri2,
            color: '#FFFFFF',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: 600,
            fontFamily: 'inherit',
          }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
